import { type FC } from "react";
import { match } from "ts-pattern";

import type { DocumentMetadata } from "@moment/api-collab/api-types";

import { isProduction } from "~/utils/env";

import { useEaselCurrentPage } from "../../hooks/useEaselCurrentPage";
import { PageArchivedBanner } from "./PageArchivedBanner";
import { ProductionBanner } from "./ProductionBanner";

export type BannersProps = {
	// context
	canvas: DocumentMetadata;
};

const clientEnv = process.env.APP_ENV;

export const Banners: FC<BannersProps> = () => {
	// Selectors/ Hooks
	const activePage = useEaselCurrentPage();

	// Variables
	const isPageArchived = activePage?.archived;

	return match({
		isPageArchived,
		isProductionEnv: !isProduction && clientEnv === "production",
	})
		.with({ isPageArchived: true }, () => <PageArchivedBanner />)
		.with({ isProductionEnv: true }, () => <ProductionBanner />)
		.otherwise(() => null);
};
